import React from 'react'

import { CommerceToolsApi } from '@grandvisionhq/commercetools'
import type { ProductDetailSlots } from '@grandvisionhq/fun-products'
import { useProductDetailContext } from '@grandvisionhq/products'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'

export type Props = React.ComponentProps<
  NonNullable<ProductDetailSlots['DynamicDeliveryIndicator']>
>

export const DeliveryIndicatorSolutionsContainer = (props: Props) => {
  const { productType } = useProductDetailContext()

  if (!CommerceToolsApi.isSolutions(productType)) {
    return null
  }

  return <FullDateDeliveryIndicatorContainer {...props} />
}
